import "react-datepicker/dist/react-datepicker.min.css";
import "./style.css";
import DatePicker from "react-datepicker";

export default DatePicker;
